/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qr_Pickup_SubmitInputs */

const vi_qr_pickup_submit = /** @type {(inputs: Qr_Pickup_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhận đơn`)
};

/**

* @param {Qr_Pickup_SubmitInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const qr_pickup_submit = /** @type {((inputs?: Qr_Pickup_SubmitInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qr_Pickup_SubmitInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_qr_pickup_submit(inputs)
});